import { render, staticRenderFns } from "./customer-trash.vue?vue&type=template&id=e66ff994&"
import script from "./customer-trash.vue?vue&type=script&lang=js&"
export * from "./customer-trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports